import { createFileRoute, useNavigate, useSearch } from "@tanstack/react-router";
import { FilterPage } from "../components/filters/FilterPage";
import { filterSearchSchema } from "../components/filters/filter-search";

/** All issues (BUILD_SPEC §12.9, §13): every issue the person may read, as the query in the address says. */
function Page() {
  const search = useSearch({ from: "/admin/filters/" });
  const navigate = useNavigate({ from: "/admin/filters/" });
  return (
    <FilterPage
      filter={null}
      search={search}
      onSearch={(next) => void navigate({ search: (prev) => ({ ...prev, ...next }), replace: next.jql !== undefined })}
    />
  );
}

export const Route = createFileRoute("/admin/filters/")({ validateSearch: filterSearchSchema, component: Page });
